module.exports = __webpack_public_path__ + "assets/img/thumb-Ultimate-Ears-Social-Static-Ad.694cd86c.jpg";